import React from 'react';
import PropTypes from 'prop-types';

import Loader from '../Loader';
import ErrorBoundary from '../ErrorBoundary';

const FetchDataWrapper = (props) => {
  const { error, isFetching = true, children } = props;

  if (error) {
    return <ErrorBoundary hasError={!!error} />;
  }

  if (isFetching) {
    return <Loader isLoading />;
  }

  return <>{children}</>;
};

FetchDataWrapper.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  error: PropTypes.any, // TODO: define error types
  isFetching: PropTypes.bool,
};

export default FetchDataWrapper;
